import { observer } from 'mobx-react';
import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
import MenuProducts from '../MenuProducts/MenuProducts';
import { CheckoutStore } from 'src/mobx/checkoutStore';
import { localeStore } from 'src/mobx/localesStore';
import { menuStore } from 'src/mobx/menuStore';
import { ICategoryWithProducts } from 'src/types/products';
import { emptyArray } from 'src/utils/helpers';
import { withCheckoutStore } from '~/view/screens/CheckoutScreen/context';
import './style.scss';

// @ts-ignore
@withCheckoutStore
@observer
export default class MenuCategories extends Component<{ checkoutStore?: CheckoutStore }, {}> {
  get checkoutStore() {
    return this.props.checkoutStore!;
  }

  selectCategory = (id: number) => () => {
    menuStore.setCategory(id);
  };

  renderCategory = (category: ICategoryWithProducts, index: number): JSX.Element => {
    return (
      <div key={category.id} className="d-flex menu-categories-wrapper mr-2">
        <div
          style={{ animationDelay: `${index * 30}ms` }}
          onClick={this.selectCategory(category.id)}
          className="animate__faster animate__animated animate__fadeInRight d-flex menu-categories-item bg_hover-mainblue color_hover-white"
        >
          <span className="family-semibold">{category.name}</span>
        </div>
      </div>
    );
  };

  renderSkeleton = (idx: number): JSX.Element => {
    return (
      <div key={String(idx) + '-category-skeleton'} className="d-flex mr-2 menu-categories__skeleton">
        <Skeleton style={{ borderRadius: 14 }} className="d-flex menu-categories-item fill-width" />
      </div>
    );
  };

  /**
   * Filter out all categories, and show only those that have one or more non-donation products
   */
  get getCategoryWithoutDonationItems(): ICategoryWithProducts[] {
    return menuStore.categories.reduce(
      (sum: ICategoryWithProducts[], current: ICategoryWithProducts) =>
        sum.concat(current.items.data.filter((item) => !item.is_donation).length ? current : []),
      []
    );
  }

  render() {
    if (!menuStore.loading && !menuStore.categories.length) {
      return (
        <div className="d-flex flex-1 flex-wrap menu-categories align-items-center justify-content-center">
          <p className="text-size-26 color-dark family-bold">{localeStore.t('no_products_found')}</p>
        </div>
      );
    }

    return (
      <div className="d-flex flex-1 flex-wrap menu-categories">
        {menuStore.parameters.search !== undefined || (menuStore.categories.length && menuStore.isSearchActive) ? (
          <MenuProducts />
        ) : !menuStore.isSearchActive ? (
          <>
            {this.checkoutStore.dependencies.customer ? (
              <div key="favorite-category" className="d-flex menu-categories-wrapper mr-2">
                <div
                  onClick={() => menuStore.changeFavoritesVisibility(true)}
                  className="d-flex menu-categories-item bg_hover-mainblue color_hover-white"
                >
                  <span className="family-semibold">{localeStore.t('favorite_items')}</span>
                </div>
              </div>
            ) : null}
            {menuStore.loading
              ? emptyArray(9).map((item, index) => this.renderSkeleton(index))
              : this.getCategoryWithoutDonationItems.map(this.renderCategory)}
          </>
        ) : null}
      </div>
    );
  }
}
